import { BANKBRANCH_LOADING, GET_BANKBRANCH, GET_BANKBRANCH_SUCCESS, GET_BANKBRANCH_FAIL, ADD_BANKBRANCH_SUCCESS, ADD_BANKBRANCH_FAIL, DELETE_BANKBRANCH_SUCCESS, DELETE_BANKBRANCH_FAIL, UPDATE_BANKBRANCH_SUCCESS, UPDATE_BANKBRANCH_FAIL, BANKBRANCH_RESET } from "./actionType";

const INIT_STATE = {
  bankBranches: [],
  error: {},
};

const BankBranch = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BANKBRANCH_SUCCESS:
      switch (action.payload.actionType) {
        case GET_BANKBRANCH:
          return {
            ...state,
            bankBranches: action.payload.data,
            isBankBranchCreated: false,
            isBankBranchSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_BANKBRANCH_FAIL:
      switch (action.payload.actionType) {
        case GET_BANKBRANCH_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isBankBranchCreated: false,
            isBankBranchSuccess: false,
            loading: false,
          };
        default:
          return { ...state, loading: false };
      }

    case GET_BANKBRANCH: {
      return {
        ...state,
        isBankBranchCreated: false,
        loading: true,
      };
    }

    case BANKBRANCH_LOADING: {
      return {
        ...state,
        isBankBranchCreated: false,
        loading: true,
      };
    }

    case ADD_BANKBRANCH_SUCCESS:
      return {
        ...state,
        isBankBranchCreated: true,
        loading: false,
        bankBranches: [action.payload.data, ...state.bankBranches],
      };

    case ADD_BANKBRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_BANKBRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        bankBranches: state.bankBranches.filter((bankBranch) => bankBranch.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_BANKBRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_BANKBRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        bankBranches: state.bankBranches.map((bankBranch) => (bankBranch.id.toString() === action.payload.data.id.toString() ? { ...bankBranch, ...action.payload.data } : bankBranch)),
      };

    case UPDATE_BANKBRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case BANKBRANCH_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default BankBranch;
